import React from 'react';

import Context                  from '../../../../../../context';
import convertNumberToPrice     from '../../../../../../utils/convertNumberToPrice';
import convertGregorianToJalali from '../../../../../../utils/convertGregorianToJalali';

import { TableNullData, UserInformation } from '../../../../../../components';

import './index.scss';

type Props = { data: any; };

const Body = ({ data }: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { factorRequest, setSelectedFactors, selectedFactors } = React.useContext(Context.PaymentOnline2CompanyContext);
  const docs = data?.data?.result?.docs;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickRow(factorId: string) {
    let newFactorList: string[] =  [...selectedFactors];
    if (selectedFactors?.find((item: string) => item === factorId)) {
      newFactorList = selectedFactors.filter(
        (item: string) => item !== factorId
      );
    } else {
      newFactorList = [...selectedFactors, factorId];
    }
    console.log(newFactorList);
    setSelectedFactors!(newFactorList);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <tbody id='find-transaction-body-container'>
      {docs?.map((factor: any, index: number) => (
        <tr key={`files-tr-${index}`} onClick={() => onClickRow(factor?._id)}>
          <td>
            <input id="checkmark" type="checkbox" name="checkmark"
              checked={!!selectedFactors?.find((item: string) => item === factor._id)}
            />
          </td>
          <td>
            <div className="table-index-number">
              {factorRequest?.page === 1 ? index + 1 : (factorRequest!.page - 1) * 10 + index + 1}
            </div>
          </td>
          <td>
            <UserInformation
              avatar={factor?.company?.avatar}
              name={factor?.company?.firstName + ' ' + factor?.company?.lastName}
              phoneNumber={factor?.driver?.phoneNumber}
            />
          </td>
          <td>
            <UserInformation
              avatar={factor?.driver?.avatar}
              name={factor?.driver?.firstName + ' ' + factor?.driver?.lastName}
              phoneNumber={factor?.driver?.phoneNumber}
            />
          </td>
          <td>
            <UserInformation
              name={factor?.parent?.firstName + ' ' + factor?.parent?.lastName}
              phoneNumber={factor?.parent?.phoneNumber}
              hideAvatar
            />
          </td>
          <td>{convertNumberToPrice(factor?.amount)} {'تومان'}</td>
          <td>{convertNumberToPrice(factor?.shares?.company + factor?.shares?.admin)} {'تومان'}</td>
          <td>{convertGregorianToJalali({date: factor?.updatedAt, format: 'hh:mm  jYYYY/jMM/jDD '})}</td>
          <td className="table-text">
            { factor?.isOnline && factor?.payerType === 'PASSENGER' && 'اپ اولیا' }
            { factor?.isOnline && factor?.payerType === 'DRIVER'    && 'اپ راننده'}
            {!factor?.isOnline && 'وب'}
          </td>
        </tr>
      ))}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Body;
